import apiFetch from '../apiFetch'

export default function (dossierTypeId, ouId, token) {
  return apiFetch({ endPoint: `DossierType/${dossierTypeId}/UO/${ouId}/Subtypes`, method: 'GET', body: null, token: token })
}
